
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate/mvpd",
      function () {
        return require("private-next-pages/activate/mvpd/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate/mvpd"])
      });
    }
  